import React, { useEffect, useState } from 'react'

import { Input } from '@centivo/react-components'

import './styles/style.scss'

const PracticeReportsSearchBox = props => {
  const { handleSubmit, initialList } = props
  const [inputValue, setInputValue] = useState('')

  const reset = () => {
    initialList({})
  }

  useEffect(() => {
    if (!inputValue) {
      reset()
    }
  }, [inputValue])

  const onSubmit = () => {
    handleSubmit(inputValue)
  }

  return (
    <div className="search-box-container col">
      <Input
        autocomplete="off"
        className="member-search"
        icon="search"
        iconPlacement="left"
        id="searchText"
        isClearable
        name="searchText"
        onChangeValue={setInputValue}
        value={inputValue}
        onClickIcon={onSubmit}
        onPressEnter={onSubmit}
        placeholder="Search by member, provider, ID, etc."
      />
    </div>
  )
}

export default PracticeReportsSearchBox
